// extracted by mini-css-extract-plugin
module.exports = {"message":"message___jdXRj","alert":"alert___3wH7L","success":"success___1k81E","warning":"warning___3jvVS","error":"error___1bYCy"};